<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des devis">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md2">
                <va-input
                  :value="searchTerm"
                  placeholder="Nom du partenaire, numéro, numéro de devis..."
                  removable
                  @input="searchText"
                >
                  <va-icon
                    name="fa fa-search"
                    slot="prepend"
                  />
                </va-input>
              </div>
              <div class="flex md2">
                <va-button
                  class="fullwidth"
                  :color="filterByAttribution ? 'success' : 'info'"
                  @click="filterByAttribution = !filterByAttribution"
                >Mes devis</va-button>
              </div>
              <div class="flex md2">
                <va-button
                  class="fullwidth"
                  :color="filterByValidation ? 'success' : 'info'"
                  @click="filterByValidation = !filterByValidation"
                >Devis non validés</va-button>
              </div>
              <div class="flex md2">
                <va-button
                  class="fullwidth"
                  :color="filterByProspection ? 'success' : 'info'"
                  @click="filterByProspection = !filterByProspection"
                >Prospection</va-button>
              </div>
              <div class="flex md2">
                <va-date-picker
                  label="Date de début"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="dateFilterStart"
                />
              </div>
              <div class="flex md2">
                <va-date-picker
                  label="Date de fin"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="dateFilterEnd"
                />
              </div>
            </div>
          </div>

          <div class="row row-inside separator">
            <div class="flex md1 col-title">Numéro de devis</div>
            <div class="flex md2 col-title">Nom du partenaire</div>
            <div class="flex md1 col-title">Date de création</div>
            <div class="flex md1 col-title">Kit média</div>
            <div class="flex md1 col-title">Devis</div>
            <div class="flex md1 col-title">Montant proposé</div>

            <div class="flex md1 col-title">Retour client</div>
            <div class="flex md2 col-title">Numéro concernés</div>

            <div class="flex md2 col-title">Attribué</div>
          </div>
          <div class="row row-inside">
            <div
              class="flex md12"
              v-for="(element, index) in listeDevis"
              :key="index"
            >
              <devis-liste-line
                :devis="element"
                v-on:reloadList="reloadList"
              />
            </div>
          </div>
          <div
            class="flex md2 offset--md10 mt-4"
            v-if="this.$store.getters.user.publication_modifications"
          >
            <va-button
              color="info"
              @click="createNew()"
            >
              <va-icon
                size="15px"
                name="fa fa-plus"
              />
              <span>&nbsp Ajouter un annonceur</span></va-button>
          </div>
        </va-card>
      </div>
    </div>
    <devis-creation
      v-model="showNewDevis"
      @newdevis="reloadList()"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, sortedUniq, sortBy, find, debounce, deburr } from "lodash";
import moment from "moment";
import DevisCreation from "./devisCreation";
import DevisListeLine from "./devisListeLine.vue";

export default {
  name: "devis-list",
  components: { DevisCreation, DevisListeLine },

  data() {
    return {
      //export within context
      moment: moment,
      showNewDevis: false,
      listeDevisFull: [],
      searchTerm: null,
      filterByAttribution: false,
      dateFilterStart: null,
      dateFilterEnd: null,
      filterByValidation: false,
      filterByProspection: false,
    };
  },
  created() {
    this.getListDevis();
  },
  watch: {},
  computed: {
    listeDevis() {
      let filteredData = sortBy(this.listeDevisFull, ["nom"]);

      return filteredData.filter((item) => {
        let boolcond = true;

        if (this.filterByAttribution) {
          boolcond =
            item.idutilisateur_attribution ===
            this.$store.getters.user.idutilisateurs;
        }

        if (this.filterByValidation) {
          boolcond = boolcond && !item.date_validation;
        }

        if (this.filterByProspection) {
          boolcond = boolcond && item.isprospection;
        } else {
          boolcond = boolcond && !item.isprospection;
        }

        if (this.searchTerm && this.searchTerm.length >= 1) {
          let searchTermClean = deburr(this.searchTerm).toLowerCase();

          boolcond =
            boolcond &&
            (deburr(item.nom).toLowerCase().includes(searchTermClean) ||
              deburr(item.nb_devis).toLowerCase().includes(searchTermClean));

          let boolcondnum = false;
          for (let ijk = 0; ijk < item.listJournal.length; ijk++) {
            if (searchTermClean === item.listJournal[ijk].numero.toString()) {
              boolcondnum = true;
            }
          }

          boolcond = boolcond || boolcondnum;
        }

        if (this.dateFilterStart) {
          console.log("test");
          boolcond =
            boolcond &&
            moment(item.date_creation, "YYYY-MM-DD").isSameOrAfter(
              moment(this.dateFilterStart, "DD-MM-YYYY")
            );
        }

        if (this.dateFilterEnd) {
          boolcond =
            boolcond &&
            moment(item.date_creation, "YYYY-MM-DD").isSameOrBefore(
              moment(this.dateFilterEnd, "DD-MM-YYYY")
            );
        }

        return boolcond;
      });
    },
  },
  methods: {
    searchText: debounce(function (searchTerm) {
      this.searchTerm = searchTerm;
    }, 400),
    async reloadList(idannonce) {
      await this.getListDevis();
      // todo open the devis for the modified annonce
    },
    async getListDevis() {
      try {
        let res = await axios.get("/api/publications-web/liste-devis");
        this.listeDevisFull = [];
        console.log(res.data);
        this.listeDevisFull = res.data;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors du chargement de la liste des devis"
        );
        console.log(error);
      }
    },
    createNew() {
      if (!this.$store.getters.user.publication_modifications) {
        return;
      }
      this.showNewDevis = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.col-title {
  font-size: 0.8em;
  text-align: center;
  font-weight: bold;
}

.separator {
  border-bottom: 1px solid black;
}
.fullwidth {
  width: 95%;
  margin: 0;
}

.container {
  text-align: center;
  min-height: 6em;
}

.container:hover {
  cursor: pointer;
}

.numero-box {
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.hors-series-text {
  color: white;
  font-size: 1em;
  font-weight: bold;
}

.date-box {
  color: white;
}

.numeroDisp-mod {
  position: relative;
  min-height: 4em;
  span {
    outline: none !important;
  }
}
.nb-pub {
  padding: 0;
  margin: 0;
  color: white;
  font-weight: bold;
  font-size: 2em;
  text-align: center;
}
.dp-pub {
  padding: 0;
  margin: 0;
  color: white;
  text-align: center;
}

.hs-pub {
  padding: 0;
  margin: 0;
  padding-top: 1em;
  color: white;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.button-left {
  position: absolute;
  left: -2.5em;
  top: 1em;
}

.button-right {
  position: absolute;
  right: -2.5em;
  top: 1em;
}
</style>
